import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import {
  Container,
  Chip,
  Button,
  IconButton,
  Typography,
  Snackbar,
  Backdrop,
  CircularProgress,
} from "@mui/material";
import { makeStyles } from "tss-react/mui";
import { AppConfig, roles, TRADE_REFERENCE_STATUS } from "../../../../configs/admin-config";
import { checkIfRoleExists, getAccessToken } from "../../../../utils/oauth";
import MuiAlert from "@mui/material/Alert";
import { useHistory } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import ConfirmationDialog from "../../Dialog/ConfirmationDialog";

const useStyles = makeStyles()((theme) => ({
  backdrop: {
    zIndex: 2,
    color: "white",
  },
  topBar: {
    marginTop: 88,
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "space-between",
    flexWrap: "wrap",
    gap: theme.spacing(1),
  },
  leftColumn: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    gap: theme.spacing(1),
    marginLeft: 45,
  },
  leftSection: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
  },
  pageTitle: {
    fontSize: 16,
    fontWeight: 500,
    color: theme.palette.text.secondary,
  },
  rightActions: {
    display: "flex",
    alignItems: "center",
    flexWrap: "wrap",
    gap: theme.spacing(1),
    marginRight: 60,
    paddingTop: theme.spacing(0.5),
  },
  emptyState: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    minHeight: "60vh",
    gap: theme.spacing(2),
  },
  emptyIconWrapper: {
    width: 72,
    height: 72,
    borderRadius: 16,
    backgroundColor: "#f1f5f9",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  emptyIcon: {
    fontSize: 36,
    color: "#64748b",
  },
  emptyTitle: {
    fontSize: 18,
    fontWeight: 600,
    color: theme.palette.text.primary,
    margin: 0,
  },
  emptySubtitle: {
    fontSize: 14,
    color: theme.palette.text.secondary,
    margin: 0,
  },
  button: {
    textTransform: "none",
  },
}));

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} variant="filled" ref={ref} {...props} />;
});

const PendingPage2 = (props) => {
  const history = useHistory();
  const { classes } = useStyles();
  const [copySnack, setCopy] = useState(false);
  const [successSnack, setSuccess] = useState(false);
  const [failSnack, setFail] = useState(false);
  const [backdropOpen, setbackDrop] = useState(false);
  const [confirmationDialog, setConfirmationDialog] = useState(null);

  useEffect(() => {
    if (!checkIfRoleExists(roles.finance) || !props.location.state) {
      history.replace({
        pathname: AppConfig.urls.NO_ACCESS_PAGE,
      });
    }
  }, []);

  const handleConfirmationDialog = (content) => {
    setConfirmationDialog(content);
  };

  const handleChangeStatus = () => {
    handleConfirmationDialog({
      title: "You are about to make a change to a reseller!",
      text: "Are you sure you want to deactivate this reseller?",
      confirmAction: () => {
        changeStatus(TRADE_REFERENCE_STATUS.DEACTIVATED);
      },
    });
  };

  const changeStatus = async (newStatus) => {
    setbackDrop(true);

    const requestURL = AppConfig.baseUrl + AppConfig.tradeReferenceFormStatus;

    let data = {
      linkId: parseInt(props.location.state.item.linkId),
      formStatus: newStatus,
      clientUrl: props.location.state.item.clientUrl || "",
    };

    try {
      let response = await fetch(requestURL, {
        method: "PATCH",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: "Bearer " + getAccessToken(),
        },
        body: JSON.stringify(data),
      });
      let body = await response.json();
      setbackDrop(false);

      if (response.status === 200) {
        setSuccess(true);
        const tradeRef = props.location.state.item;
        if (newStatus === TRADE_REFERENCE_STATUS.DEACTIVATED) {
          history.push({
            pathname: AppConfig.urls.ADMIN + AppConfig.urls.DEACTIVATED_PAGE + tradeRef.linkId,
            state: props.location.state
          });
        }
      } else {
        console.error(body.message);
        setFail(true);
      }
      return null;
    } catch (error) {
      console.error(error);
      setbackDrop(false);
      setFail(true);
      return error;
    }
  };

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setSuccess(false);
    setFail(false);
    setCopy(false);
  };

  return (
    <>
      <Container maxWidth={false} style={{ paddingLeft: 16, paddingRight: 16 }}>
        <Backdrop open={backdropOpen} className={classes.backdrop}>
          <CircularProgress color="secondary" />
        </Backdrop>
        <Snackbar
          open={successSnack}
          autoHideDuration={3000}
          onClose={handleClose}
         
        >
          <Alert onClose={handleClose} severity="success">
            Success!
          </Alert>
        </Snackbar>
        <Snackbar
          open={copySnack}
          autoHideDuration={3000}
          onClose={handleClose}
         
        >
          <Alert onClose={handleClose} severity="success">
            Copied to Clipboard!
          </Alert>
        </Snackbar>
        <Snackbar
          open={failSnack}
          autoHideDuration={3000}
          onClose={handleClose}
         
        >
          <Alert onClose={handleClose} severity="error">
            Server Error!
          </Alert>
        </Snackbar>

        <div className={classes.topBar}>
          <div className={classes.leftColumn}>
            <div className={classes.leftSection}>
              <NavLink to={AppConfig.urls.ADMIN + "home/tradereferences"}>
                <IconButton aria-label="back">
                  <ArrowBackIcon />
                </IconButton>
              </NavLink>
              <Typography className={classes.pageTitle}>
                Return to Dashboard
              </Typography>
            </div>

            <Chip
              variant="outlined"
              label={"Form Status: Pending"}
              color={"primary"}
              style={{ marginLeft: 12 }}
            />
          </div>

          <div className={classes.rightActions}>
            {(checkIfRoleExists(roles.admin) ||
              checkIfRoleExists(roles.channelManager)) && (
              <Button
                className={classes.button}
                variant="outlined"
                color="primary"
                onClick={handleChangeStatus}
              >
                Deactivate
              </Button>
            )}
          </div>
        </div>

        <div className={classes.emptyState}>
          <div className={classes.emptyIconWrapper}>
            <DescriptionOutlinedIcon className={classes.emptyIcon} />
          </div>
          <Typography className={classes.emptyTitle}>
            Form not submitted yet
          </Typography>
          <Typography className={classes.emptySubtitle}>
            {props.location.state?.item?.companyName}has not filled out the form yet
          </Typography>
        </div>
      </Container>
      {confirmationDialog && (
        <ConfirmationDialog
          content={confirmationDialog}
          handleOpen={handleConfirmationDialog}
        />
      )}
    </>
  );
};

export default PendingPage2;
